import { render, staticRenderFns } from "./RejectCall.vue?vue&type=template&id=8f0735b8&"
import script from "./RejectCall.vue?vue&type=script&lang=js&"
export * from "./RejectCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports